import { Typography as MuiTypography } from '@mui/material';

export default MuiTypography;
